import React from "react";
import config from "./../../../config/config";

const Metodos =( props) => {
    let {className} = props;
    return(
        <div className={`${className}wc metodosIcons text-center`}>
            <img src={config.pagosProcesadosEpaycoLogo} alt="logo-epayco" style={{ maxHeight: "20px" }} />
            <div className="mt-3">
                <p className="font-weight-bold small">Medio de pago disponible</p>
                <div>
                <img src="/img/pse.png" alt="" />
                <img src="/img/dinners.png" alt="" />
                <img src="/img/amex.png" alt="" />
                <img src="/img/mastercard.png" alt="" />
                <img src="/img/visa.png" alt="" />
                </div>
            </div>
        </div>
    )
}

export default Metodos;
